import { render, staticRenderFns } from "./mod-06.vue?vue&type=template&id=1daa848f&scoped=true&"
import script from "./mod-06.vue?vue&type=script&lang=js&"
export * from "./mod-06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daa848f",
  null
  
)

export default component.exports